// Set all branches to default state

export const DEFAULT_STATE = '@ezylead/DEFAULT_STATE';

// Set network branch to default state

export const DEFAULT_NETWORK_BRANCH_STATE = '@ezylead/DEFAULT_NETWORK_BRANCH_STATE';
